export const productName = 'MEGAPACK AUTOMATIZACIÓN INDUSTRIAL LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/8piYzd7zJ8T4JRLNEx45zb/MOCKUP.png';

export const checkoutUrl = 'https://megapack-automatizacion-industrial-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$124.000 ARS';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = '$76.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos de Automatización Industrial',
  'TOMO 2: Sensores, Actuadores e Instrumentación Industrial',
  'TOMO 3: PLC: Programación y Control Industrial',
  'TOMO 4: Electroneumática y Automatismos Industriales',
  'TOMO 5: Motores Eléctricos, Variadores y Control de Movimiento',
  'TOMO 6: Redes y Comunicaciones Industriales',
  'TOMO 7: HMI, SCADA y Supervisión de Procesos Industriales',
  'TOMO 8: 100 Prácticas y Desafíos de Automatización Industrial',
  'TOMO 9: Planificación Docente, Secuencias y Proyectos de Automatización Industrial',
  'BONO 1: Banco de 150 Proyectos de Automatización Industrial Listos para Adaptar',
  'BONO 2: Kit Completo de Evaluaciones de Automatización Industrial',
  'BONO 3: Banco de Diagramas, Esquemas y Recursos Visuales',
  'BONO 4: Kit de Documentación Técnica, Formularios y Plantillas (155 recursos)',
  'BONO 5: Seguridad y Puesta en Marcha Segura en Automatización Industrial',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% técnico y actualizado', 'Normas industriales vigentes, contexto laboral real, políticas de automatización en Argentina y casos de máquinas y procesos argentinos.'],
  ['Material imprimible', 'Listo para usar en el aula, taller o laboratorio, o entregar directamente al estudiante técnico.'],
  ['Formularios y plantillas reales', 'Esquemas, programas Ladder, diagramas de conexión, proyectos adaptados a 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo de la automatización industrial en Argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles educativos.'],
  ['Conexión con la actualidad', 'Nuevas tecnologías, nuevos protocolos, nuevas máquinas, industria 4.0, IoT industrial.'],
  ['Seguridad integrada', 'Procedimientos de puesta en marcha segura en cada proyecto y práctica.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
